import {
    BarChartOutlined, ClockCircleOutlined,
    CloudServerOutlined,
    CopyOutlined, FileExcelOutlined,
    FileTextOutlined,
    GiftOutlined, GlobalOutlined,
    HeartOutlined, HistoryOutlined, MailOutlined, MessageOutlined, MoneyCollectOutlined,
    MonitorOutlined, PieChartOutlined,
    RadarChartOutlined, SafetyOutlined,
    ShopOutlined, ToolOutlined,
    UserOutlined
} from "@ant-design/icons";
import {Avatar, Menu, Layout, Typography} from "antd";
import {Link, useLocation} from "react-router-dom";
import LunchFairy from "../assets/images/lunchFairy.png";
import GameIcon from "../assets/images/gamepad.png";
import SoloIcon from "../assets/images/solo.png";
import {useContext} from "react";
import {AuthContext} from "../shared/contexts/authContext";
import {ROLE_OPTIONS} from "../shared/utils/enum";
import {DarkModeContext} from "../shared/contexts/darkModeContext";

const {Sider} = Layout;
const {Text, Title} = Typography;

const getRoleText = (role) => {
    return ROLE_OPTIONS.find((option) => option.value === role).label;
}

const isDocker = process.env.REACT_APP_ENV === 'docker';

const filterDockerHidden = (items) =>
    items
        .filter(item => !(isDocker && item.dockerHidden))
        .map(item => ({
            ...item,
            children: item.children ? filterDockerHidden(item.children) : undefined,
        }));

const SideBar = ({ collapsed }) => {
    const {currentUser} = useContext(AuthContext);
    const {darkMode} = useContext(DarkModeContext);
    const location = useLocation();

    const menuItems = [
        {
            key: 'user-management',
            icon: <UserOutlined/>,
            label: '사용자 관리',
            children: [
                {
                    key: '/player',
                    icon: <UserOutlined/>,
                    label: <Link to="/player">유저 정보</Link>,
                },
                {
                    key: '/playerCopy',
                    icon: <CopyOutlined/>,
                    label: <Link to="/playerCopy">유저 정보 복사</Link>,
                },
            ],
        },
        {
            key: 'content-management',
            icon: <FileTextOutlined/>,
            label: '게임 관리',
            children: [
                {
                    key: '/event',
                    icon: <GiftOutlined/>,
                    label: <Link to="/event">이벤트</Link>,
                },
                {
                    key: '/shopPackage',
                    icon: <ShopOutlined/>,
                    label: <Link to="/shopPackage">상품 관리</Link>,
                },
                {
                    key: '/itemProbability',
                    icon: <PieChartOutlined/>,
                    label: <Link to="/itemProbability">확률표</Link>,
                    dockerHidden: true,
                },
                {
                    key: '/inApp',
                    icon: <MoneyCollectOutlined/>,
                    label: <Link to="/inApp">인앱상품</Link>,
                    dockerHidden: true,
                },
                {
                    key: '/characterPackage',
                    icon: <GiftOutlined/>,
                    label: <Link to="/characterPackage">캐릭터 패키지</Link>,
                },
                // {
                //     key:'/passMaster',
                //     icon: <GiftOutlined/>,
                //     label: <Link to="/passMaster">시즌 패스</Link>,
                // },
                // {
                //     key:'/badgeMaster',
                //     icon: <GiftOutlined/>,
                //     label: <Link to="/badgeMaster">뱃지</Link>,
                // },
                {
                    key:'/mergeEventMaster',
                    icon: <GiftOutlined/>,
                    label: <Link to="/mergeEventMaster">머지 이벤트</Link>,
                },
                {
                    key:'/seasonThemeMaster',
                    icon: <GiftOutlined/>,
                    label: <Link to="/seasonThemeMaster">시즌 테마</Link>,
                },
                {
                    key: '/popupMaster',
                    icon: <FileTextOutlined/>,
                    label: <Link to="/popupMaster">오픈 팝업 관리</Link>,
                },
                {
                    key: '/trophyChallenge',
                    icon: <GiftOutlined/>,
                    label: <Link to="/trophyChallenge">트로피 챌린지</Link>,
                }
            ],
        },
        {
            key: 'communication',
            icon: <MessageOutlined/>,
            label: '운영',
            children: [
                {
                    key: '/notice',
                    icon: <FileTextOutlined/>,
                    label: <Link to="/notice">공지사항</Link>,
                },
                // {
                //     key: '/cs',
                //     icon: <CustomerServiceOutlined/>,
                //     label: <Link to="/cs">고객센터</Link>,
                // },
                {
                    key: '/message',
                    icon: <MessageOutlined/>,
                    label: <Link to="/message">Push 알림</Link>,
                },
                {
                    key: '/campaign',
                    icon: <MailOutlined/>,
                    label: <Link to="/campaign">전체 우편</Link>,
                },
                // TODO: 나중에 업데이트
                // {
                //     key: '/push-campaign',
                //     icon: <MessageOutlined/>,
                //     label: <Link to="/push-campaign">푸시 캠페인</Link>,
                // },
                {
                    key: '/coupon',
                    icon: <GiftOutlined/>,
                    label: <Link to="/coupon">쿠폰</Link>,
                },
                {
                    key: '/refund',
                    icon: <MoneyCollectOutlined/>,
                    label: <Link to="/refund">환불</Link>,
                    dockerHidden: true,
                },
                {
                    key: '/logs',
                    icon: <HistoryOutlined/>,
                    label: <Link to="/logs">로그</Link>,
                },
                {
                    key: '/hack',
                    icon: <RadarChartOutlined/>,
                    label: <Link to="/hack">해킹 감지</Link>,
                    dockerHidden: true,
                },
                {
                    key: 'receiptFinder',
                    icon: <FileTextOutlined/>,
                    label: <Link to="/receiptFinder">영수증 찾기(애플)</Link>,
                    dockerHidden: true,
                },
            ],
        },
        {
            key: 'system',
            icon: <MonitorOutlined/>,
            label: '시스템 관리',
            children: [
                {
                    key: '/csv',
                    icon: <FileExcelOutlined/>,
                    label: <Link to="/csv">CSV</Link>,
                },
                {
                    key: '/serverInfo',
                    icon: <CloudServerOutlined/>,
                    label: <Link to="/serverInfo">서버 정보</Link>,
                },
                {
                    key: '/country',
                    icon: <GlobalOutlined/>,
                    label: <Link to="/country">국가/언어</Link>,
                    dockerHidden: true,
                },
                {
                    key: '/admin',
                    icon: <SafetyOutlined/>,
                    label: <Link to="/admin">관리자</Link>,
                    dockerHidden: true,
                },
            ],
        },
        {
            key: 'analytics',
            icon: <BarChartOutlined/>,
            label: '분석 및 통계',
            dockerHidden: true,
            children: [
                {
                    key: '/statistics',
                    icon: <BarChartOutlined/>,
                    label: <Link to="/statistics">통계</Link>,
                },
            ],
        },
        {
            key: 'tools',
            icon: <ToolOutlined/>,
            label: '도구',
            dockerHidden: true,
            children: [
                {
                    key: '/lunchFairy',
                    icon: <img src={LunchFairy} alt="점메추 아이콘" style={{ width: 16, height: 16, borderRadius: '3px' }} />,
                    label: <Link to="http://192.168.0.199:3000/ ">점메추 요정</Link>,
                },
                {
                    key: '/timestampConverter',
                    icon: <ClockCircleOutlined/>,
                    label: <Link to="/timestampConverter">타임스탬프 변환</Link>,
                },
                {
                    key: 'jsonManager',
                    icon: <FileTextOutlined/>,
                    label: <Link to="/json">JSON 뷰어</Link>,
                },
                {
                    key: 'logStream',
                    icon: <FileTextOutlined/>,
                    label: <Link to="/logStream">실시간 로그 보기</Link>,
                }
            ],
        },
        {
            key: 'gameCollection',
            icon: <img src={GameIcon} alt="게임 아이콘" style={{ width: 16, height: 16, borderRadius: '3px' }} />,
            label: '게임',
            dockerHidden: true,
            children: [
                {
                    key: '/',
                    icon: <img src={SoloIcon} alt="혼자놀기 아이콘" style={{ width: 16, height: 16, borderRadius: '3px' }} />,
                    label: <Link to="/solo-games">혼자 놀기(베타)</Link>,
                },
                // {
                //     key: '/games',
                //     icon: <img src={MultiIcon} alt="같이놀기 아이콘" style={{ width: 16, height: 16, borderRadius: '3px' }} />,
                //     label: <Link to="/games">같이 놀기(베타)</Link>,
                // },
            ],
        },
    ];

    // 현재 경로를 기반으로 선택된 메뉴 키 계산
    const getSelectedKeys = () => {
        if (location.pathname === '/') return [];
        return [location.pathname];
    };

    // 현재 경로를 기반으로 열린 서브메뉴 키 계산
    const getOpenKeys = () => {
        if (location.pathname === '/') return [];
        const openKeys = [];
        for (const item of menuItems) {
            if (item.children) {
                const hasActiveChild = item.children.some(child => child.key === location.pathname);
                if (hasActiveChild) {
                    openKeys.push(item.key);
                }
            }
        }
        return openKeys;
    };
    return (
        <Sider
            trigger={null}
            collapsible
            collapsed={collapsed}
            className="layout-sider"
            width={260}
            collapsedWidth={80}
            theme={darkMode ? 'dark' : 'light'}
        >
            {/* 로고 섹션 - 높이 줄임 */}
            <Link to="/" style={{textDecoration: 'none', color: 'inherit', display: 'block'}}>
                <div className="logo-container" style={{cursor: 'pointer'}}>
                    <div className="logo-icon">
                        <HeartOutlined style={{fontSize: '24px', color: '#fff'}}/>
                    </div>
                    {!collapsed && (
                        <div className="logo-content">
                            <Title level={5} className="logo-title">Hello Kitty</Title>
                            <Text className="logo-subtitle">Admin Dashboard</Text>
                        </div>
                    )}
                </div>
            </Link>

            {/* 사용자 정보 카드 - 간소화 */}
            {!collapsed && (
                <div className="user-info-section">
                    <div className="user-info-compact">
                        <Avatar
                            src="https://img.utdstc.com/icon/e7b/286/e7b2860763114b21dc1cba6b59c619fc865bf7d8016459b51c5602d63cf62de8:200"
                            size="default"
                        />
                        <div className="user-details">
                            <Text strong style={{
                                color: darkMode ? '#fff' : '#1a1a1a',
                                fontSize: '14px'
                            }}>
                                {currentUser?.name}
                            </Text>
                            <Text type="secondary" style={{fontSize: '11px'}}>
                                {getRoleText(currentUser?.role)} • 온라인
                            </Text>
                        </div>
                    </div>
                </div>
            )}

            {/* 메뉴 - 서브메뉴로 개선 */}
            <Menu
                theme={darkMode ? 'dark' : 'light'}
                mode="inline"
                selectedKeys={getSelectedKeys()}
                defaultOpenKeys={getOpenKeys()}
                items={filterDockerHidden(menuItems)}
                className="layout-menu"
                inlineCollapsed={collapsed}
            />
        </Sider>
    )
}

export default SideBar;

